import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Footer from '../CreateAppointment/components/Footer';

import EditAppointmentForm from '../_forms/EditAppointmentForm';

import theme from './EditAppointment.scss';

const propTypes = {
  isExternalInit: PropTypes.bool.isRequired,
};

const EditAppointment = props => (
  <div className={ classnames(theme.root, { [theme.withFooter]: props.isExternalInit }) }>
    <EditAppointmentForm { ...props } />
    <If condition={ props.isExternalInit }>
      <Footer />
    </If>
  </div>
);

EditAppointment.propTypes = propTypes;

export default EditAppointment;
